const logotext = "ONLINE";
const meta = {
    title: "Planungsbüro Richard",
    description: "Planungsbüro Richard",
};

const introdata = {
    title: "PLANUNGSBÜRO RICHARD",
    animated: {
        second: "Architektur",
        third: "Innenarchitektur",
    },
    description: `Wir sind leidenschaftliche Professionalisten, die das Ziel haben Räume zu schaffen, die konstruktiven und ästhetischen Aspekten gerecht werden und den Nutzern vielseitigen Mehrwert bieten.

Unser Tätigkeitsfeld erstreckt sich von der Entwurfsplanung bis zur Bauüberwachung und Fertigstellung - sowohl im privaten als auch im gewerblichen Bereich bieten wir Ihnen durch unsere Erfahrung bestmögliche Planungssicherheit bei der Umsetzung Ihrer Bauvorhaben.

- B E R A T U N G
- E N T W U R F
- V I S U A L I S I E R U N G
- B A U A N T R A G
- A U S F Ü H R U N G
- Ü B E R W A C H U N G

`,

    your_img_url: "images/logo.jpg",
};

const worktimelinemarco = [{
    jobtitle: "Gründung Planungsbüro Richard",
    where: "Architektur Innenarchitektur",
    date: "2008",
},
{
        jobtitle: "Einstellung als Architekt in der Planung Projektleitung und Bauleitung in ",
        where: "Hannover",
        date: "2004 - 2007",
    },

];

const studytimelinemarco = [{
    jobtitle: "Projektleitung in einem Architekturbüro in ",
    where: "Sarstedt",
    date: "1997 - 1999",
},
{
    jobtitle: "Projektleitung in einem Architekturbüro in ",
    where: "Hannover",
    date: "1999 - 2004",
},
];

const activitytimelinemarco = [{
        jobtitle: "Studium an der Universität in ",
        where: "Hannover",
        date: "1997 - 2004",
},
];

const experiencetimelinemarco = [{
        jobtitle: "Ausbildung zum Bauzeichner im Hochbau in ",
        where: "Sarstedt",
        date: "1995 - 1997",
},
];




const worktimelinenatalie = [
    {
        jobtitle: "Ausbildung zur Bauzeichnerin im Hochbau in ",
        where: "Samtgemeinde Wesendorf",
        date: "1992 - 1995",
    },
    {
        jobtitle: "Fachhochschulreife Fachoberstufe Technik in",
        where: "Gifhorn",
        date: "1995 - 1996",
    },
    {
        jobtitle: "Einstellung als Bauzeichnerin in ",
        where: "Hannover",
        date: "1997 - 1999",
    },
    {
        jobtitle: "Beruflicher Einsatz als Bauzeichnerin in ",
        where: "Frankfurt am Main",
        date: "1999 - 2001",
    },
];

const studytimelinenatalie = [{
    jobtitle: "Hochschule für Wissenschaft und Kunst in ",
    where: "Hildesheim",
    date: "2001 - 2005",
},
];

const activitytimelinenatalie = [
  {
        jobtitle: "Architekturbüro in ",
        where: "Hannover",
        date: "2002 - 2005",
    },
    {
        jobtitle: "Architekturbüro in ",
        where: "Frankfurt am Main",
        date: "2001 - 2002",
    },
    {
        jobtitle: "Innenarchitekturbüro in ",
        where: "Hildesheim",
        date: "1997 - 2001",
    },
 

  
];

const experiencetimelinenatalie = [
    {
        jobtitle: "Leitung der Innenarchitekturabteilung Planungsbüro Richard in ",
        where: "Hannover",
        date: "2013",
    },
    {
        jobtitle: "Einstellung als leitende Innenarchitektin in einem Innenarchitekturbüro in",
        where: "Hannover",
        date: "2005 - 2013",
    },
];

const dataportfolio = [
     {
        img: "images/VR.jpg",
        desctiption: "Virtuelle Realität LIVE erleben",
        link: "images/VR.jpg",
    },
   {
        img: "images/01.jpg",
        desctiption: "Vereinsheim, Arnum, 2020",
        link: "images/01_.jpg",
    },
   {
        img: "images/SWA_03.jpg",
        desctiption: "Fertigstellung 2025",
        link: "https://www.instagram.com/planungsbuerorichard/",
    },
   {
        img: "images/SWA_04.jpg",
        desctiption: "Fertigstellung 2025",
        link: "https://www.instagram.com/planungsbuerorichard/",
    },
  {
        img: "images/02.jpg",
        desctiption: "Bürogebäude, Hannover, 2020",
        link: "images/02_.jpg",
    },
    {
        img: "images/03.jpg",
        desctiption: "Hotel, Prag, 2022",
        link: "images/03_.jpg",
    },
    {
        img: "images/04.jpg",
        desctiption: "Doppelhaus, Hannover, 2021",
        link: "images/04_.jpg",
    },    
    {
        img: "images/05.jpg",
        desctiption: "48 Wohneinheiten, Wedemark, 2024",
        link: "images/05_.jpg",
    },
    {
        img: "images/06.jpg",
        desctiption: "Reihenhäuser, Wedemark, 2021",
        link: "images/06_.jpg",
    },
    {
        img: "images/07.jpg",
        desctiption: "20 Wohneinheiten, Wedemark, 2020",
        link: "images/07_.jpg",
    },
    {
        img: "images/08.jpg",
        desctiption: "Beispielbild",
        link: "images/08_.jpg",
    },
   {
        img: "images/Logo.jpg",
        desctiption: "PLANUNGSBÜRO RICHARD",
        link: "",
    },
   {
        img: "images/SWA_01.jpg",
        desctiption: "Fertigstellung 2025",
        link: "https://www.instagram.com/planungsbuerorichard/",
    },
   {
        img: "images/SWA_02.jpg",
        desctiption: "Fertigstellung 2025",
        link: "https://www.instagram.com/planungsbuerorichard/",
    },
];

const socialprofils = {
    instagram: "https://www.instagram.com/planungsbuerorichard/"
};

const followLink = {
    text: 'Follow us'
}

export {
    followLink,
    meta,
    dataportfolio,
    worktimelinemarco,
    introdata,
    socialprofils,
    logotext,
    studytimelinemarco,
    activitytimelinemarco,
    experiencetimelinemarco,
    worktimelinenatalie,
    studytimelinenatalie,
    activitytimelinenatalie,
    experiencetimelinenatalie
};
